import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '../components/Icon.jsx';
import { useEinstellungenSpeichern, useVerwaltungEinstellungen } from '../hooks/data.js';
import { useToast } from '../state/toast.jsx';
import { Feld, QuellePill } from './Feld.jsx';
import { Speichern } from './Speichern.jsx';

const gleich = (a, b) => JSON.stringify(a) === JSON.stringify(b);

/**
 * Einstellungen der Firma, gruppiert. Änderungen sammeln sich und gehen mit «Speichern» gemeinsam an die API;
 * was ki|partner verwaltet, steht schreibgeschützt darunter.
 */
export function Einstellungen({ online }) {
  const q = useVerwaltungEinstellungen();
  const speichern = useEinstellungenSpeichern();
  const toast = useToast();
  const [aenderungen, setAenderungen] = useState({});
  const [fehler, setFehler] = useState('');
  const [weitere, setWeitere] = useState(false);

  if (q.isError && !q.data) return <div className="empty" role="alert">{q.error.message}<button className="btn" onClick={() => q.refetch()}>Erneut versuchen</button></div>;
  if (!q.data) return <div className="skeleton" style={{ height: 240 }} />;

  const { einstellungen, gruppen } = q.data;
  const eigene = einstellungen.filter((e) => e.bearbeitbar);
  const fremde = einstellungen.filter((e) => !e.bearbeitbar);
  const anzahl = Object.keys(aenderungen).length;

  const aendern = (e, v) => {
    setFehler('');
    setAenderungen((alt) => {
      const neu = { ...alt };
      const server = e.typ === 'liste' ? e.liste : e.wert ?? '';
      if (v !== null && gleich(v, server)) delete neu[e.name]; else neu[e.name] = v;
      return neu;
    });
  };
  const absenden = async () => {
    setFehler('');
    try {
      await speichern.mutateAsync(aenderungen);
      setAenderungen({});
      toast({ text: anzahl === 1 ? 'Einstellung gespeichert' : `${anzahl} Einstellungen gespeichert` });
    } catch (err) {
      setFehler(err.message);
    }
  };

  return (
    <>
      <Link to="/apps" className="card mehrkachel" style={{ minHeight: 'auto' }}>
        <span className="mehrico"><Icon name="extra" size={24} stroke={2.2} /></span>
        <span className="stack" style={{ gap: 2, flex: 1 }}>
          <span className="h2">Module</span>
          <span className="sub">Ein- und ausschalten, beantragen</span>
        </span>
        <Icon name="chevron" size={20} stroke={2.4} style={{ color: 'var(--muted-2)' }} />
      </Link>
      {Object.entries(gruppen).map(([g, titel]) => {
        const felder = eigene.filter((e) => e.gruppe === g);
        if (!felder.length) return null;
        return (
          <section key={g} className="card stack" style={{ gap: 20 }} aria-label={titel}>
            <h2 className="h2">{titel}</h2>
            {felder.map((e) => (
              <Feld key={e.name} e={e} wert={aenderungen[e.name]} geaendert={e.name in aenderungen} onChange={(v) => aendern(e, v)} />
            ))}
          </section>
        );
      })}

      {fremde.length > 0 && (
        <section className="card stack" style={{ gap: 12 }}>
          <button type="button" className="plainrow between" style={{ padding: '4px 0' }} aria-expanded={weitere} onClick={() => setWeitere(!weitere)}>
            <span className="h2">Von ki|partner verwaltet ({fremde.length})</span>
            <span className="sub">{weitere ? 'Ausblenden' : 'Anzeigen'}</span>
          </button>
          {weitere && fremde.map((e) => (
            <div key={e.name} className="listrow" style={{ alignItems: 'flex-start' }}>
              <span className="stack" style={{ gap: 2, flex: 1, minWidth: 0 }}>
                <span style={{ fontWeight: 800 }}>{e.titel}</span>
                <span className="sub ellipsis" style={{ fontSize: 13 }}>
                  {e.typ === 'geheim' ? (e.gesetzt ? '•••••• (gesetzt)' : 'nicht gesetzt') : (e.typ === 'liste' ? e.liste.join(', ') : e.wert) || '–'}
                </span>
              </span>
              <QuellePill quelle={e.quelle} />
            </div>
          ))}
        </section>
      )}

      <Speichern anzahl={anzahl} fehler={fehler} online={online} speichert={speichern.isPending}
        onVerwerfen={() => { setAenderungen({}); setFehler(''); }} onSpeichern={absenden} />
    </>
  );
}
